import { useState } from 'react';

// "please select create new command" is raised by a click handler sitting on
// the whole master control contents pane, so it is asked to raise on every
// click the user makes — including all the clicks made while building a
// command, when the prompt is simply not true.
//
// It must therefore never latch. Raising it while a command exists clears it
// instead, otherwise it sits armed behind the render guard and surfaces the
// moment handleSaveCommand clears isNewCommandCreated, which reads as "the
// command was not applied".
export const useCreateNewCommandPrompt = (isNewCommandCreated) => {
  const [isPromptRaised, setIsPromptRaised] = useState(false);

  return {
    isPromptVisible: isPromptRaised && !isNewCommandCreated,
    raisePrompt: () => setIsPromptRaised(!isNewCommandCreated),
    dismissPrompt: () => setIsPromptRaised(false),
  };
};
